import { v4 as uuid } from "uuid";

type DashboardProps = {
  targetDate?: string;
  days?: number;
  currentDate?: Date;
  currentDateTime?: number;
  incrementerDay?: number;
}

type Sales = {
  date: string;
  quantitySales: number;
}

type LastSales = {
  price: number,
  name: string,
  unity: string,
  quantity: number;
}

type FinancialData = {
  date: string;
  positive: number;
  negative: number;
}

type ProfitByType = {
  type: string;
  profit: number;
}

type RankingByType = {
  type: string;
  name: string;
  profit: number;
}

const categories = [
  {
    id: uuid(),
    title: "Eletrônicos",
    created_at: new Date(),
    updated_at: new Date()
  }
];

const carriers = [
  {
    id: uuid(),
    name: "Log Sul",
    region: "Sul",
    created_at: new Date(),
    updated_at: new Date()
  }
];

const providers = [
  {
    id: uuid(),
    name: "Fornecedor 1",
    email: "fornecedor1@mail.com",
    tel: "(11) 11111-1111",
    created_at: new Date(),
    updated_at: new Date()
  }
];

const stores = [
  {
    id: uuid(),
    name: "Loja 1",
    type: "Matriz",
    created_at: new Date(),
    updated_at: new Date()
  },
  {
    id: uuid(),
    name: "Loja 2",
    type: "Filial",
    created_at: new Date(),
    updated_at: new Date()
  },
  {
    id: uuid(),
    name: "Loja 3",
    type: "Franquia",
    created_at: new Date(),
    updated_at: new Date()
  },
  {
    id: uuid(),
    name: "Loja 4",
    type: "Revendedora",
    created_at: new Date(),
    updated_at: new Date()
  }
];

const users = [
  {
    id: uuid(),
    name: "Administração",
    email: "administracao@mail.com",
    password: "1234",
    unity_id: stores[0].id,
    position: "Administração",
    permissions: "view_dashboard,view_store,create_store,update_store,delete_store,view_product,create_product,update_product,delete_product,view_client,create_client,update_client,delete_client,view_sale,create_sale,update_sale,delete_sale,view_carrier,create_carrier,update_carrier,delete_carrier,view_provider,create_provider,update_provider,delete_provider,view_seller,create_seller,update_seller,delete_seller,view_purchase,create_purchase,update_purchase,delete_purchase,view_financial,create_financial,update_financial,delete_financial,view_user,create_user,update_user,delete_user,view_ticket,create_ticket,update_ticket,delete_ticket,create_category,view_category,get_stores,get_categories,get_providers,get_products,get_clients,get_sellers,get_carriers,get_users",
    active: true,
    created_at: new Date(),
    updated_at: new Date()
  },
  {
    id: uuid(),
    name: "Depósito",
    email: "deposito@mail.com",
    password: "1234",
    unity_id: stores[0].id,
    position: "Depósito",
    permissions: "view_dashboard,view_product,create_product,update_product,delete_product,view_provider,create_provider,update_provider,delete_provider,view_purchase,create_purchase,update_purchase,delete_purchase,view_ticket,create_ticket,update_ticket,delete_ticket,create_category,view_category,get_categories,get_stores,get_providers,get_products",
    active: true,
    created_at: new Date(),
    updated_at: new Date()
  },
  {
    id: uuid(),
    name: "Vendas",
    email: "vendas@mail.com",
    password: "1234",
    unity_id: stores[0].id,
    position: "Vendas",
    permissions: "view_dashboard,view_client,create_client,update_client,delete_client,view_sale,create_sale,update_sale,delete_sale,view_ticket,create_ticket,update_ticket,delete_ticket,get_stores,get_products,get_clients,get_sellers,get_carriers",
    active: true,
    created_at: new Date(),
    updated_at: new Date()
  },
  {
    id: uuid(),
    name: "Financeiro",
    email: "financeiro@mail.com",
    password: "1234",
    unity_id: stores[0].id,
    position: "Financeiro",
    permissions: "view_dashboard,view_financial,create_financial,update_financial,delete_financial,view_ticket,create_ticket,update_ticket,delete_ticket,get_stores",
    active: true,
    created_at: new Date(),
    updated_at: new Date()
  },
];

const products = [
  {
    id: uuid(),
    name: "Produto 1",
    description: "Descrição produto 1",
    purchase_price: 123,
    sale_price: 456,
    category_id: categories[0].id,
    unity_id: stores[0].id,
    provider_id: providers[0].id,
    user_id: users[0].id,
    lot: 123456,
    validity: new Date("2999-12-31"),
    quantity: 7,
    sold_amount: 1,
    created_at: new Date(),
    updated_at: new Date()
  },
  {
    id: uuid(),
    name: "Produto 2",
    description: "Descrição produto 2",
    purchase_price: 20,
    sale_price: 30,
    category_id: categories[0].id,
    unity_id: stores[0].id,
    provider_id: providers[0].id,
    user_id: users[0].id,
    lot: 123456,
    validity: new Date("2999-12-31"),
    quantity: 100,
    sold_amount: 0,
    created_at: new Date(),
    updated_at: new Date()
  },
  {
    id: uuid(),
    name: "Produto 3",
    description: "Descrição produto 3",
    purchase_price: 50,
    sale_price: 75,
    category_id: categories[0].id,
    unity_id: stores[0].id,
    provider_id: providers[0].id,
    user_id: users[0].id,
    lot: 123456,
    validity: new Date("2999-12-31"),
    quantity: 12,
    sold_amount: 0,
    created_at: new Date(),
    updated_at: new Date()
  },
  {
    id: uuid(),
    name: "Produto 4",
    description: "Descrição produto 4",
    purchase_price: 80,
    sale_price: 120,
    category_id: categories[0].id,
    unity_id: stores[0].id,
    provider_id: providers[0].id,
    user_id: users[0].id,
    lot: 123456,
    validity: new Date("2999-12-31"),
    quantity: 6,
    sold_amount: 0,
    created_at: new Date(),
    updated_at: new Date()
  },
  {
    id: uuid(),
    name: "Produto 5",
    description: "Descrição produto 5",
    purchase_price: 100,
    sale_price: 200,
    category_id: categories[0].id,
    unity_id: stores[0].id,
    provider_id: providers[0].id,
    user_id: users[0].id,
    lot: 123456,
    validity: new Date("2999-12-31"),
    quantity: 4,
    sold_amount: 0,
    created_at: new Date(),
    updated_at: new Date()
  }
];

const sellers = [
  {
    id: uuid(),
    user_id: users[0].id,
    user: users[0].name,
    commission: 12,
    created_at: new Date(),
    updated_at: new Date()
  }
];

const clients = [
  {
    id: uuid(),
    name: "Cliente 1",
    email: "cliente1@mail.com",
    tel: "(99) 99999-9999",
    cep: "88888888",
    city: "Cidade",
    state: "UF",
    user_id: users[0].id,
    unity_id: stores[0].id,
    created_at: new Date(),
    updated_at: new Date()
  }
];

const tickets = [
  {
    id: uuid(),
    title: "Ticket 1",
    description: "Descrição do ticket 1",
    unity_id: stores[0].id,
    user_id: users[0].id,
    status: 0,
    created_at: new Date(),
    updated_at: new Date()
  }
];

const financial = [
  {
    id: uuid(),
    type: 0,
    unity_id: stores[0].id,
    user_id: users[0].id,
    value: 25,
    created_at: new Date(),
    updated_at: new Date()
  },
  {
    id: uuid(),
    type: 1,
    unity_id: stores[0].id,
    user_id: users[0].id,
    value: 50,
    created_at: new Date(),
    updated_at: new Date()
  }
];

const purchases = [
  {
    id: uuid(),
    user_id: users[0].id,
    unity_id: stores[0].id,
    provider_id: providers[0].id,
    product_id: products[0].id,
    quantity: 5,
    unit_price: 60,
    status: 0,
    created_at: new Date(),
    updated_at: new Date()
  }
];

const sales = [
  {
    id: uuid(),
    product_id: products[0].id,
    unity_id: stores[0].id,
    client_id: clients[0].id,
    seller_id: sellers[0].id,
    carrier_id: carriers[0].id,
    quantity: 1,
    status: 0,
    created_at: new Date(),
    updated_at: new Date()
  }
];

export function populateLocalStorage () {
  const isPopulated = localStorage.getItem('isPopulated');

  if (isPopulated !== null) {
    return true;
  } else {
    localStorage.setItem('categories', JSON.stringify(categories));
    localStorage.setItem('carriers', JSON.stringify(carriers));
    localStorage.setItem('providers', JSON.stringify(providers));
    localStorage.setItem('stores', JSON.stringify(stores));
    localStorage.setItem('users', JSON.stringify(users));
    localStorage.setItem('products', JSON.stringify(products));
    localStorage.setItem('sellers', JSON.stringify(sellers));
    localStorage.setItem('clients', JSON.stringify(clients));
    localStorage.setItem('tickets', JSON.stringify(tickets));
    localStorage.setItem('financial', JSON.stringify(financial));
    localStorage.setItem('purchases', JSON.stringify(purchases));
    localStorage.setItem('sales', JSON.stringify(sales));

    localStorage.setItem('isPopulated', 'populated');
  }

}

export function populateDashboard (targetDate: string, days: number) {
  const id = localStorage.getItem('token');
  const storage = JSON.parse(localStorage.getItem('users')!);
  const user = storage.find((user: any) => user.id === id);
  const type = user.position;

  const getSalesRoles = ['Administração', 'Financeiro', 'Vendas'];
  const getProductsRoles = ['Administração', 'Vendas', 'Depósito'];
  const getFinancialRoles = ['Administração', 'Financeiro'];
  const getStoresRoles = ['Administração'];

  const currentDate = new Date(targetDate);
  const currentDateTime = currentDate.getTime();
  const incrementerDay = 86400000;

  const dashboardProps: DashboardProps = {
    targetDate,
    days,
    currentDate,
    currentDateTime,
    incrementerDay
  }

  const result: any = {
    sales: {},
    products: {},
    financial: {},
    stores: {}
  };

  const getSales =
    getSalesRoles.includes(type)
      ?
      getSalesDashboardController(dashboardProps)
      :
      '';

  const getProducts =
    getProductsRoles.includes(type)
      ?
      getProductsDashboardController()
      :
      '';

  const getFinancial =
    getFinancialRoles.includes(type)
      ?
      getFinancialDashboardController(dashboardProps)
      :
      '';

  const getStores =
    getStoresRoles.includes(type)
      ?
      getStoresDashboardController(dashboardProps)
      :
      '';

  result.sales = getSales;
  result.products = getProducts;
  result.financial = getFinancial;
  result.stores = getStores;

  return {
    result: {
      ...result
    }
  };
}

function formatDate (date: Date) {
  const day = date.getUTCDate();
  const month = date.getUTCMonth();
  return `${day.toString().padStart(2, '0')}/${(month + 1).toString().padStart(2, '0')}`;
}

function getSalesDashboardService (minDate: string) {
  const salesStorage = localStorage.getItem('sales');
  const productsStorage = localStorage.getItem('products');

  const salesFiltered = JSON.parse(salesStorage!)

  let result: any = [];

  salesFiltered.map((item: any) => {
    let thisProduct = JSON.parse(productsStorage!).find((product: any) => product.id === item.product_id);
    result.push({
      purchase_price: thisProduct.purchase_price,
      sale_price: thisProduct.sale_price,
      name: thisProduct.name,
      updated_at: item.updated_at
    })
  });

  return result;
}

function getLastSalesDashboardService (minDate: string) {
  const salesStorage = localStorage.getItem('sales');
  const productsStorage = localStorage.getItem('products');
  const storesStorage = localStorage.getItem('stores');

  const salesFiltered = JSON.parse(salesStorage!)

  let result: any = [];

  salesFiltered.map((item: any) => {
    let thisProduct = JSON.parse(productsStorage!).find((product: any) => product.id === item.product_id);
    let thisStore = JSON.parse(storesStorage!).find((store: any) => store.id === item.unity_id);
    result.push({
      sale_price: thisProduct.sale_price,
      name: thisProduct.name,
      unity: thisStore.name
    })
  });

  return result;
}

function getProductsDashboardService (quantity: number) {
  const productsStorage = localStorage.getItem('products');
  let result: any = [];
  result.push(...JSON.parse(productsStorage!));
  return result;
}

function getFinancialDashboardService (minDate: string) {
  const financialStorage = localStorage.getItem('financial');
  let result: any = [];
  result.push(...JSON.parse(financialStorage!));
  return result;
}

function getStoresDashboardService (minDate: string) {
  let salesStorage = localStorage.getItem('sales');
  let productsStorage = localStorage.getItem('products');
  let storesStorage = localStorage.getItem('stores');

  let result: any = [];
  JSON.parse(salesStorage!).map((item: any) => {
    let thisProduct = JSON.parse(productsStorage!).find((product: any) => product.id === item.product_id);
    let thisStore = JSON.parse(storesStorage!).find((store: any) => store.id === item.unity_id);
    result.push({
      purchase_price: thisProduct.purchase_price,
      sale_price: thisProduct.sale_price,
      type: thisStore.type,
      unity: thisStore.name
    })
  })
  return result;
}

function getSalesDashboardController ({ targetDate, days, currentDateTime, incrementerDay }: DashboardProps) {
  const getSales: any = getSalesDashboardService(targetDate!);
  let arrayDatesSales: any[] = [];

  for (let i = 0; i < days!; i++) {
    arrayDatesSales.push({
      date: formatDate(new Date(currentDateTime! + (incrementerDay! * i))),
      quantitySales: 0
    })
  }

  getSales.map((item: any) => {
    let newDate = new Date(item.updated_at);
    let formattedDate = `${newDate.getDate().toString().padStart(2, '0')}/${(newDate.getMonth() + 1).toString().padStart(2, '0')}`;
    let findIndex = arrayDatesSales.findIndex((dateSale) => dateSale.date === formattedDate);
    if (findIndex > -1) {
      arrayDatesSales[findIndex].quantitySales += 1;
    }
  });

  let today = new Date();
  const todayFormattedDate = `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;

  const getLastSales: any = getLastSalesDashboardService(todayFormattedDate);
  const resultSales = {
    list: [] as Sales[],
    lastSales: [] as LastSales[],
    invested: 0,
    received: 0,
    profit: 0
  }

  getLastSales.map((item: any) => {
    resultSales.lastSales.push({
      price: item.sale_price,
      name: item.name,
      unity: item.unity,
      quantity: 1
    })
  })

  getSales.map((item: any) => {
    resultSales.invested += item.purchase_price;
    resultSales.received += item.sale_price;
  });

  resultSales.profit = resultSales.received - resultSales.invested;
  resultSales.list = arrayDatesSales;

  return resultSales;
}

function getProductsDashboardController () {
  const getProducts: any = getProductsDashboardService(5);
  const resultProducts = {
    list: {},
    averageTotalTicket: 0
  };
  let valueSales = 0;
  let quantitySales = 0;
  let averageTotalTicket = 0;

  getProducts.map((item: any) => {
    quantitySales += item.sold_amount;
    valueSales += item.sale_price * item.sold_amount;
  })

  averageTotalTicket = valueSales / quantitySales;

  resultProducts.list = getProducts.map((item: any) => {
    return {
      name: item.name,
      sold_amount: item.sold_amount
    }
  });
  resultProducts.averageTotalTicket = Math.floor(averageTotalTicket);

  return resultProducts;
}

function getFinancialDashboardController ({ targetDate, days, currentDateTime, incrementerDay }: DashboardProps) {
  const getFinancial: any = getFinancialDashboardService(targetDate!);
  let arrayDatesFinancial: any[] = [];

  for (let i = 0; i < days!; i++) {
    arrayDatesFinancial.push({
      date: formatDate(new Date(currentDateTime! + (incrementerDay! * i))),
      negative: 0,
      positive: 0
    })
  }

  getFinancial.map((item: any) => {
    let newDate = new Date(item.updated_at);
    let formattedDate = `${newDate.getDate().toString().padStart(2, '0')}/${(newDate.getMonth() + 1).toString().padStart(2, '0')}`;
    let findIndex = arrayDatesFinancial.findIndex((dateSale) => dateSale.date === formattedDate);
    if (findIndex > -1) {
      if (item.type === 0) {
        arrayDatesFinancial[findIndex].negative += -Math.abs(item.value);
      } else {
        arrayDatesFinancial[findIndex].positive += item.value;
      }
    }
  });

  const resultFinancial = {
    list: [] as FinancialData[],
    totalEntries: 0,
    totalOutputs: 0,
    difference: 0
  };

  getFinancial.map((item: any) => {
    if (item.type === 0) {
      resultFinancial.totalOutputs += item.value
    } else {
      resultFinancial.totalEntries += item.value
    }
  });

  resultFinancial.difference = resultFinancial.totalEntries - resultFinancial.totalOutputs;
  resultFinancial.list = arrayDatesFinancial;

  return resultFinancial;
}

function getStoresDashboardController ({ targetDate }: DashboardProps) {
  const getStores: any = getStoresDashboardService(targetDate!);
  let formattedRankingByType: RankingByType[] = [];
  let orderRankingByType: RankingByType[] = [];
  const resultStores = {
    profitByType: [] as ProfitByType[],
    rankingByType: [] as RankingByType[]
  }

  getStores.map((item: any) => {
    let findIndex = formattedRankingByType.findIndex((store: RankingByType) => store.name === item.unity);
    if (findIndex > -1) {
      formattedRankingByType[findIndex].profit += item.sale_price - item.purchase_price;
    } else {
      formattedRankingByType.push({
        type: item.type,
        name: item.unity,
        profit: item.sale_price - item.purchase_price
      });
    }
  });

  formattedRankingByType.map((item) => {
    let findIndex = orderRankingByType.findIndex((store: RankingByType) => store.type === item.type);
    if (findIndex > -1) {
      if (item.profit > orderRankingByType[findIndex].profit) {
        orderRankingByType[findIndex].name = item.name
        orderRankingByType[findIndex].profit = item.profit
      }
    } else {
      orderRankingByType.push({
        name: item.name,
        type: item.type,
        profit: item.profit
      });
    }
  });

  resultStores.rankingByType = orderRankingByType.sort((a: any, b: any) => {
    if (a.profit === b.profit) {
      return 0;
    }

    return a.profit > b.profit ? -1 : 1;
  });

  getStores.map((item: any) => {
    let findIndex = resultStores.profitByType.findIndex((store: ProfitByType) => store.type === item.type);
    if (findIndex > -1) {
      resultStores.profitByType[findIndex].profit += item.sale_price - item.purchase_price;
    } else {
      resultStores.profitByType.push({
        type: item.type,
        profit: item.sale_price - item.purchase_price
      });
    }
  });

  return resultStores;
}

export function getRegisters (endpoint: string, currentPage: number, query: string = '') {
  const result = localStorage.getItem(endpoint);
  const formattedResult = [
    JSON.parse(result!).length,
    JSON.parse(result!)
  ]
  return {
    [endpoint]: formattedResult
  }
}

export function fetchAllData (endpoint: string, currentPage: number, query: string = '') {
  const result = localStorage.getItem(endpoint);
  const formattedResult = [
    JSON.parse(result!).length,
    JSON.parse(result!)
  ]
  return {
    [endpoint]: formattedResult
  }
}

export function createRegister (endpoint: string, data: Object) {
  const thisData = {
    ...data,
    id: uuid(),
    created_at: new Date(),
    updated_at: new Date()
  }
  const result = localStorage.getItem(endpoint);
  const resultParse = JSON.parse(result!);
  const thisResult = [...resultParse, thisData];
  localStorage.setItem(endpoint, JSON.stringify(thisResult));
  return {
    [endpoint]: thisData
  };
}

export function updateRegister (endpoint: string, id: string, data: Object) {
  let result = localStorage.getItem(endpoint);
  let resultParse = JSON.parse(result!);
  let index = resultParse.findIndex((item: any) => item.id === id);
  resultParse[index] = data;
  localStorage.setItem(endpoint, JSON.stringify(resultParse));
  return {
    [endpoint]: data
  };
}

export function deleteRegister (endpoint: string, id: string) {
  const result = localStorage.getItem(endpoint);
  let resultParse = JSON.parse(result!);
  let index = resultParse.findIndex((item: any) => item.id === id);
  resultParse.splice(index, 1);
  localStorage.setItem(endpoint, JSON.stringify(resultParse));
  return { status: true };
}
